'use client'
import {ApolloProvider} from '@apollo/client';
import {client} from '@/libs/api/apolloClient';

export default function ApolloClientProvider({ children }) {
	return <ApolloProvider client={client}>{children}</ApolloProvider>
}

